import ApiService from '../services/ApiService';

export default class EventParticipantRepository {
    constructor() {
        this.apiService = new ApiService();
    }

    getParticipants(eventId, sort = '') {
        return new Promise((resolve, reject) => {
            this.apiService
                .get(`event-participants/${eventId}?sort=${sort}`)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    updateParticipant(eventId, userId, appeared) {
        return new Promise((resolve, reject) => {
            const data = {
                appeared: appeared,
                user_id: userId
            };

            this.apiService
                .put(`event-participants/${eventId}`, data)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
}
